import { useState } from "react";
import { toast } from "sonner";
import { Settings, Loader2 } from "lucide-react";
import api, { externalRedirect } from "@/lib/api";

export default function Manage() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMsg(null);
    try {
      const { data } = await api.post("/portal", { email, origin_url: window.location.origin });
      if (data.available && data.portal_url) {
        externalRedirect(data.portal_url);
      } else {
        setMsg(data.message);
      }
    } catch (err) {
      const d = err.response?.data?.detail;
      setMsg(typeof d === "string" ? d : "We couldn't find a subscription for that email.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="manage-page" className="mx-auto max-w-xl px-5 py-20">
      <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-accent text-accent-foreground">
        <Settings className="h-6 w-6" />
      </span>
      <h1 className="mt-5 font-heading text-3xl font-extrabold tracking-tight">Manage your subscription</h1>
      <p className="mt-3 text-muted-foreground">
        Enter the email you booked with. After your plan minimum (3 visits monthly, 2 quarterly),
        you can pause or cancel through your secure Stripe portal.
      </p>
      <form onSubmit={submit} className="mt-8 space-y-4">
        <input
          data-testid="manage-email"
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="you@example.com"
          className="w-full rounded-xl border border-border bg-muted/50 px-4 py-3 focus:bg-card focus:outline-none focus:ring-2 focus:ring-primary"
        />
        <button data-testid="manage-submit" type="submit" disabled={loading}
          className="inline-flex w-full items-center justify-center gap-2 rounded-xl bg-primary px-7 py-3.5 font-bold text-primary-foreground transition-all hover:brightness-110 disabled:opacity-50">
          {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : "Open Customer Portal"}
        </button>
      </form>
      {msg && (
        <div data-testid="manage-message" className="mt-5 rounded-xl border border-border bg-card p-4 text-sm text-muted-foreground">
          {msg}
        </div>
      )}
    </div>
  );
}
